<div class="filter-item" [formGroup]="filtersForm">
  <span class="input-label">{{ filterItem.caption }}</span>

  <div class="input-wrap select">
    <select class="input" [formControlName]="filterItem.name">
      <option [value]="''" selected="selected">
        {{ filterItem.placeholder }}
      </option>

      <option *ngFor="let ddlItem of items" [ngValue]="ddlItem.key">
        {{ ddlItem.value }}
      </option>
    </select>
  </div>
</div>
